import {createStore, applyMiddleware, compose} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {reducer, saga} from './reducers'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [
  sagaMiddleware
]

const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancer = composeEnhancers(applyMiddleware(...middlewares))

export default createStore(
  reducer,
  {},
  enhancer
)
console.log('running saga middleware')
sagaMiddleware.run(saga)
